import React from 'react';
import HlsVideoPlayer from './HlsVideoPlayer';
import { getStore, usePlayerStore } from '../../../stores/StoreContext';
import { config } from '../../../config';
import VideoRenderer from '../VideoRenderer';
import HoverControls from '../Controls/HoverControls';
import Overlays from '../Overlays';
import { View } from '@smarterservices/smarter-ui';
import { usePlayerHotkeys } from '../hooks/usePlayerHotkeys';
import { useSmartSpeed } from '../hooks/useSmartSpeed';
import CONSTANTS from '../../../config/constants';

function HlsMedia() {
  const PlayerStore = getStore('playerStore');
  const ExamSessionStore = getStore('examSessionStore');

  const canHaveLiveVideo = usePlayerStore(
    (state) => state.canHaveLiveVideo
  );
  const viewRawHlsVideo = usePlayerStore(
    (state) => state.viewRawHlsVideo
  );

  // Initialize player hotkeys and smart speed for raw video mode
  usePlayerHotkeys();
  useSmartSpeed();

  // Centralized callbacks for HLS player
  const handleBufferingStart = ({ bufferAhead, speed, targetBuffer }) => {
    PlayerStore.setOverlay(CONSTANTS.OVERLAYS.BUFFERING);
  };

  const handleBufferingEnd = ({ bufferAhead, speed }) => {
    PlayerStore.setOverlay(null);
  };

  const handleOnPlaying = ({ currentTime, playbackRate }) => {
    // Clear buffer overlay when video actually starts playing
    // This prevents stuck buffer overlays
    PlayerStore.setOverlay(null);
  };

  const handleSuggestedSpeedChange = ({ suggestedSpeed, currentSpeed, previousSuggestion, metrics }) => {
    if (suggestedSpeed !== currentSpeed) {
      PlayerStore.setSuggestedPlaybackSpeed(suggestedSpeed);
    }
  };

  return (
    <View
      as="div"
      className={viewRawHlsVideo ? "raw-video-wrapper" : "integrated-video-wrapper"}
      position="relative"
      width="100%"
      height="100%"
      overflow="hidden"
      onMouseEnter={() => viewRawHlsVideo && PlayerStore.setShowHoverControls(true)}
      onMouseLeave={() => viewRawHlsVideo && PlayerStore.setShowHoverControls(false)}
    >
      {/* HLS video player - always rendered in same location to preserve playback position */}
      <HlsVideoPlayer
        url={`${config.media.playback.baseUrl}/v1/${ExamSessionStore.getHlsAuthenticationToken()}/installs/${ExamSessionStore.installSid}/exams/${ExamSessionStore.examSid}/sessions/${ExamSessionStore.sessionSid}/playlist.m3u8`}
        showRawVideo={viewRawHlsVideo}
        onBufferingStart={handleBufferingStart}
        onBufferingEnd={handleBufferingEnd}
        onSuggestedSpeedChange={handleSuggestedSpeedChange}
        onPlaying={handleOnPlaying}
      />

      {/* Only show integrated VideoRenderer if not viewing raw HLS video */}
      {!canHaveLiveVideo && !viewRawHlsVideo && (
        <VideoRenderer />
      )}

      {/* Raw video controls and overlays - only shown in raw mode */}
      {viewRawHlsVideo && (
        <>
          <HoverControls />
          <View as="div" textAlign="center" width="100%" height="100%">
            <Overlays />
          </View>
        </>
      )}
    </View>
  );
}

export default HlsMedia;
